import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Extract a safe string message from any axios error response
export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return e?.message || "Virhe";
};

// Parse a decimal that accepts comma or dot (Finnish/EU locales).
// Returns a finite number or null when input is invalid/empty.
export const parseDecimal = (raw) => {
  if (raw == null || raw === "") return null;
  const cleaned = String(raw).trim().replace(",", ".").replace(/\s+/g, "");
  if (cleaned === "" || cleaned === "-" || cleaned === ".") return null;
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : null;
};

export const parseInteger = (raw) => {
  if (raw == null || raw === "") return null;
  const n = parseInt(String(raw).trim(), 10);
  return Number.isFinite(n) ? n : null;
};
